import React, { useState } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { Button } from "react-bootstrap";
import decrypt from "./lib/decrypt";

export default function GetPin(props) {
  const [showOverlay, setShowOverlay] = useState(false);
  const [error, setError] = useState(false);
  const [pin, setPin] = useState(false);
  const [notActivated, setNotActivated] = useState(false);

  function getPin() {
    setShowOverlay(true);
    if (!window.OrendaGetResponse || window.isSiteBuilder) {
      setTimeout(() => {
        setPin("1234");
        setShowOverlay(false);
      }, 1000);
      return;
    }

    return window.OrendaGetResponse({ event_name: "getPin" }, (response) => {
      if (response.error) return setError(true);
      if (!response.pin) return setNotActivated(true);
      setPin(
        decrypt(response.pin, response.account_details.account_type).substr(
          0,
          4
        )
      );
      setShowOverlay(false);
      return;
    });
  }

  if (error)
    return (
      <div className="orenda-frontend">
        <div className="loader pin-error message">
          <p>Unfortunately an error occured.</p>
        </div>
      </div>
    );

  if (notActivated)
    return (
      <div className="orenda-frontend">
        <div className="loader pin-not-active message">
          <p>You haven't activated your physical card.</p>
        </div>
      </div>
    );

  if (showOverlay)
    return (
      <div className="orenda-frontend">
        <div className="loader spinner">
          <ClipLoader size={20} />
          <span className="message">Please wait...</span>
        </div>
      </div>
    );

  if (pin)
    return (
      <div className="orenda-frontend">
        <div className="loader pin message">
          <p>Your pin is {pin}</p>
        </div>
      </div>
    );

  return (
    <div className="orenda-frontend">
      <Button
        className="getpin"
        variant="outline-dark"
        onClick={() => getPin()}
      >
        Get Pin
      </Button>
    </div>
  );
}
